module.exports = __webpack_public_path__ + "img/xlsx.ad0a2d05.png";